<ion-header class="form-header">
  <ion-toolbar class="modal-toolbar">
    <ion-title class="modal-title">Tables or Rooms</ion-title>
    <ion-buttons slot="end">
      <ion-button class="btn-design" (click)="onSaveClick()">Save</ion-button>
      <ion-button class="btn-design" (click)="onCloseClick()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form *ngIf="form" [formGroup]="form" class="table-form">
    <ion-list formArrayName="tables">
      <ion-item lines="inset" class="table-header">
        <ion-label class="header-cell">QR</ion-label>
        <ion-label class="header-cell">Code</ion-label>
        <ion-label class="header-cell">Capacity</ion-label>
        <ion-label class="header-cell">Captain</ion-label>
        <ion-label class="header-cell ion-text-end">Action</ion-label>
      </ion-item>

      <ion-item
        lines="inset"
        class="table-row"
        *ngFor="let table of tables; let i = index"
        [formArrayName]="i"
      >
        <div class="cell qr-cell">
          <ion-icon
            *ngIf="table?.tableId; else noQr"
            name="qr-code-outline"
            class="qr-icon"
            (click)="onQrClick($event, table)"
          ></ion-icon>
          <ng-template #noQr>
            <ion-icon class="qr-icon"></ion-icon>
          </ng-template>
        </div>

        <div class="cell">
          <ion-input
            formControlName="tableCode"
            placeholder="Code"
          ></ion-input>
          <ion-text color="danger" *ngIf="tableControls.at(i).get('tableCode')?.invalid && tableControls.at(i).get('tableCode')?.touched">
            <small>Table code is required.</small>
          </ion-text>
        </div>

        <div class="cell">
          <ion-input
            type="number"
            formControlName="capacity"
            placeholder="Capacity"
          ></ion-input>
          <ion-text color="danger" *ngIf="tableControls.at(i).get('capacity')?.invalid && tableControls.at(i).get('capacity')?.touched">
            <small>Capacity is required.</small>
          </ion-text>
        </div>

        <div class="cell">
          <ion-input
            type="text"
            formControlName="captain"
            placeholder="Captain"
          ></ion-input>
        </div>

        <div class="cell action-cell">
          <ion-button
            color="danger"
            fill="clear"
            (click)="onDeleteTable($event, table, i)"
          >
            <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
          </ion-button>
        </div>
      </ion-item>

      <ng-container *ngIf="!tables?.length">
        <ion-item lines="none" class="ion-text-center no-data">
          <ion-label>No Tables or Rooms to Display!</ion-label>
        </ion-item>
      </ng-container>

      <div class="ion-text-center action ">
        <ion-button class="add-btn" fill="outline" size="small" (click)="onNewClick()">
          New Table or Room
        </ion-button>
      </div>
    </ion-list>
  </form>
</ion-content>

